import React, { Component } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";
import config from "../../../../config";

class CreateBlindFabricPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: [
        {
          id: "name",
          label: "Style Name",
          type: "text",
          tooltip: "Please Enter Blind Style Name",
          required: true
        },
        {
          id: "photo",
          label: "Photo URL",
          type: "text",
          tooltip: "Please Enter Photo URL",
          required: false
        },
        {
          id: "manufacturerId",
          label: "Manufacturer ID",
          type: "AlgoliaSelect",
          index: `${config.algolia.prefix}manufacturers_name_asc`,
          filters: "isDeleted:false"
        },
        {
          id: "priceLists",
          label: "Associated Price Lists",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_price_lists_name_asc`,
          value: []
        },
        {
          id: "associatedServices",
          label: "Associated Services",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_services_fees_name_asc`,
          value: []
        }
      ]
    };
  }

  APIMethod = async formData => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      const body = {
        details: {
          name: formData.name,
          photo: formData.photo,
          priceLists: formData.priceLists,
          manufacturerId: formData.manufacturerId,
          associatedServices: formData.associatedServices
        }
      };
      this.props.history.push(`/products/blinds/fabric`);
      await API.post("telishadeAPI", "/product/blind/component/fabric", {
        body
      });
      this.props.dispatch(setAlgoliaLoaderState(false));
      this.props.dispatch(setRefresh(true));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Blind Fabric"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    );
  }
}

export default connect()(CreateBlindFabricPopUp);
